import { IconSymptomCheckerVector } from '@medifind/icons';
import { useRouter } from '@medifind/router';
import AdWrapper from './adWrapper';

const SecondOpinionAd = ({ personId, ...props }) => {
  const router = useRouter();
  const { query } = router;
  const { projectId } = query || {};

  const href = (() => {
    if (personId) {
      const projectIdQuery = projectId ? `&projectId=${projectId}` : '';
      return `/second-opinion/search?personId=${personId}${projectIdQuery}`;
    }
    const projectIdQuery = projectId ? `?projectId=${projectId}` : '';
    return `/second-opinion/search${projectIdQuery}`;
  })();

  return (
    <AdWrapper
      {...props}
      icon={<IconSymptomCheckerVector fill="#761E91" background="#fff" />}
      title={'Is this your doctor?'}
      onClick={() => router.history.push(href)}
      buttonText={'Find A Second Opinion'}
    />
  );
};

export { SecondOpinionAd as default, SecondOpinionAd };
